import { useEffect, useState } from 'react';
import { Button } from '../../components/Button';
import { ButtonBack } from '../../components/ButtonBack';
import { Card } from '../../components/Card';
import { HelmetComponent } from '../../components/Helmet';
import { List, ListItem } from '../../components/List';
import { useAuth } from '../../hooks/useAuth';
import { api } from '../../server/api';
import { RenderDetailsProspect } from './components/RenderDetailsComponents';
import { Input } from '../../components/forms/Input';

interface IProspects {
  name: string;
  email: string;
  phoneNumber?: string;
  leads?: string;
  id: string;
}

export function Prospects() {
  const { client, player } = useAuth();
  const [playersGuest, setPlayersGuest] = useState<Array<IProspects>>([]);
  const [isViewAll, setIsViewAll] = useState<boolean>(false);
  const [guestSearch, setGuestSearch] = useState<string>('');

  useEffect(() => {
    getPlayersGuest();
  }, []);

  const getPlayersGuest = async () => {
    try {
      const parameters = {
        userType: 'player',
        searchFunctionality: 'getGuestPlayer',
        playerId: player.id,
        clientId: client.id,
      };

      const { data } = await api.post('/search', parameters);

      if (data.success) {
        const { playersGuest } = data.data;

        setPlayersGuest(playersGuest);
      }
    } catch (error) {
      console.log('error getPlayersGuest', error);
    }
  };

  const handleViewAll = () => {
    setIsViewAll(!isViewAll);
  };

  const filteredGuests = playersGuest?.filter((guest) =>
    guest.name.toLowerCase().includes(guestSearch?.toLowerCase())
  );

  return (
    <>
      <HelmetComponent
        clientLogoURL={client?.logoURL}
        companyName={client?.companyName}
        clientFavicon={client?.favIcon}
        primaryColor={client?.primaryColor}
        secondaryColor={client?.secondaryColor}
        tabTitle={'Meus prospectos'}
      />
      <div className="container">
        <div className="row">
          <div className="my-3">
            <ButtonBack title="Meus prospectores" />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-sm-12 col-md-12 mb-12 mb-3">
            <label>Pesquise pelo nome do prospector</label>
            <Input
              name="Prospector"
              placeholder="Nome do prospector"
              type="text"
              onChange={(e) => {
                setGuestSearch(e.target.value);
              }}
            />
          </div>
          <div className="col-12 col-sm-12 col-md-12 mb-12 mb-3">
            <Card>
              <>
                <List>
                  {/* Exibi uma lista de 10 itens, caso ultrapasse mostrar o "Ver mais" */}
                  {isViewAll ? (
                    <>
                      {filteredGuests?.map((prospect) => (
                        <ListItem
                          key={prospect.id}
                          icon="person"
                          content={prospect.name}
                          secondaryContent={prospect.leads}
                          expansible={true}
                          contentExpansible={
                            <RenderDetailsProspect
                              mail={prospect.email}
                              phone={
                                prospect.phoneNumber
                                  ? prospect.phoneNumber
                                  : 'Não informado'
                              }
                            />
                          }
                        />
                      ))}
                    </>
                  ) : (
                    <>
                      {filteredGuests.slice(0, 10).map((prospect) => (
                        <ListItem
                          key={prospect.id}
                          icon="person"
                          content={prospect.name}
                          secondaryContent={prospect.leads}
                          expansible={true}
                          contentExpansible={
                            <RenderDetailsProspect
                              mail={prospect.email}
                              phone={
                                prospect.phoneNumber
                                  ? prospect.phoneNumber
                                  : 'Não informado'
                              }
                            />
                          }
                        />
                      ))}
                    </>
                  )}
                </List>

                {filteredGuests && filteredGuests.length > 10 && (
                  <div className="d-flex justify-content-center mt-4">
                    <Button
                      onClick={handleViewAll}
                      text={`Ver ${!isViewAll ? 'todos' : 'menos'}`}
                      color="flat"
                      icon="add"
                    />
                  </div>
                )}
              </>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
}
